const second = 1000;
const minute = 60 * second;
const hour = 60 * minute;
const day = 24 * hour;

/** Returns a human readable text that represents the difference between 2 dates. */
export function getHumanReadableTimeDifference(
  date: Date,
  otherDate: Date,
): string {
  const differenceInMilliseconds =
    otherDate.getTime() > date.getTime()
      ? otherDate.getTime() - date.getTime()
      : date.getTime() - otherDate.getTime();

  if (differenceInMilliseconds < 1 * minute) {
    return 'less than a minute';
  }

  let totalMillisecondsLeft = differenceInMilliseconds;

  const daysLeft = Math.floor(totalMillisecondsLeft / day);
  totalMillisecondsLeft -= daysLeft * day;

  const hoursLeft = Math.floor(totalMillisecondsLeft / hour);
  totalMillisecondsLeft -= hoursLeft * hour;

  const minutesLeft = Math.floor(totalMillisecondsLeft / minute);
  totalMillisecondsLeft -= minutesLeft * minute;

  const timeParts = [
    ...(daysLeft > 0 ? [`${daysLeft} ${daysLeft === 1 ? 'day' : 'days'}`] : []),
    ...(hoursLeft > 0
      ? [`${hoursLeft} ${hoursLeft === 1 ? 'hour' : 'hours'}`]
      : []),
    ...(minutesLeft > 0
      ? [`${minutesLeft} ${minutesLeft === 1 ? 'minute' : 'minutes'}`]
      : []),
  ] as const;

  return timeParts.length === 1
    ? timeParts[0]
    : [
        timeParts.slice(0, timeParts.length - 1).join(', '),
        timeParts[timeParts.length - 1],
      ].join(' and ');
}
